<div class="row  text-center">
    <div class="col-md-12">
        <i-tabler name="lock" class="icon-50 d-flex icon"></i-tabler>
    </div>
    <div class="col-md-12">
        <h1>{{'NotAuthorized'|translate}}</h1>
        <p>{{'YouAreNotAuthorized'|translate}}</p>
        <p>{{'Please'|translate}} <a href="/login">{{'Login'|translate}}</a> {{'toContinue'|translate}}</p>
    </div>
</div>